import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.title',
		defaultMessage: 'Some child items are linked to other projects',
		description: 'Title for the update child work item links confirmation modal',
	},
	description: {
		id: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.description',
		defaultMessage:
			'Linking this project will also replace the project for all child items under this work item. <Link>More on project inheritance</Link>',
		description: 'Description for the update child work item links confirmation modal',
	},
	cancelButton: {
		id: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'The cancel button label on the update child work item links confirmation modal',
	},
	linkButton: {
		id: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.link-button',
		defaultMessage: 'Link work item',
		description: 'The link button label on the update child work item links confirmation modal',
	},
});
export default messages;
